require.register("app/restaurant/show/TrameTab", function(exports, require, module){
  $0
  
});

